import { Component } from '@angular/core';
import { VxFormFieldErrorDefaultDirective } from '@ui/form-field/form-field-error-default.directive';
import { SharedModule } from 'src/app/core/shared.module';

/**
 * The app-wide messages for common validators, rendered once in the app
 * root. Every `<vx-form-field>` falls back to them, so pages only declare
 * messages that are specific to them (`vxFormFieldError`).
 */
@Component({
  selector: 'app-form-error-messages',
  templateUrl: './form-error-messages.component.html',
  imports: [SharedModule, VxFormFieldErrorDefaultDirective],
})
export class FormErrorMessagesComponent {}
